import { Box, Flex, Text } from '@chakra-ui/react';
import { add, format, getTime } from 'date-fns';

const Timeline = ({ date }: { date: number | string }) => {
    const interval = [0, 10, 20, 30, 40, 50];

    return (
        <Flex position="absolute" right={0} left={0} height="100%" top="0" bottom="-24px" pointerEvents="none">
            {interval.map((item, index) => (
                <Box
                    width={`${100 / interval.length}%`}
                    borderRight={interval.length - 1 === index ? 'none' : '1px'}
                    borderColor="gray.200"
                    height="100%"
                    position="relative"
                    key={item}
                >
                    <Text
                        fontSize="12px"
                        color="gray.500"
                        position="absolute"
                        bottom="100%"
                        transform="translateX(-50%)"
                    >
                        {format(getTime(add(date, { minutes: item })), 'hh:mm a')}
                    </Text>
                </Box>
            ))}
            <Box height="100%" position="relative">
                <Text
                    fontSize="12px"
                    color="gray.500"
                    position="absolute"
                    bottom="100%"
                    whiteSpace="nowrap"
                    transform="translateX(-50%)"
                >
                    {format(getTime(add(date, { minutes: 60 })), 'hh a')}
                </Text>
            </Box>
        </Flex>
    );
};

export default Timeline;
